import { TOwnedLicenses } from "@src/entities/user/api/interfaces/userInfoMeResponseDto";
import dayjs, { MSK_TZ } from "@src/shared/lib/dayjs";

export type EndDate = string | null; // "YYYY-MM-DD"

export function isLicenseExpired(endDate: EndDate) {
  if (!endDate) return false;
  const todayMsk = dayjs().tz(MSK_TZ);
  const endMsk = dayjs.tz(endDate, MSK_TZ);
  return todayMsk.isAfter(endMsk, "day");
}

export function formatEndDateRu(endDate: string) {
  return dayjs.tz(endDate, MSK_TZ).format("D MMMM YYYY");
}

export function getActiveEndDate(
  licenses: TOwnedLicenses | undefined | null,
): string | null {
  if (!licenses) return null;
  return licenses?.end_date ?? null;
}
